"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.peopleResponseConverterAws = void 0;
const AuthService_1 = __importDefault(require("../services/AuthService"));
const BaseController_1 = __importDefault(require("./BaseController"));
const peopleResponseConverterAws = (people) => {
    return people.map((awsPerson, index) => ({
        id: index + 1,
        label: `${awsPerson.display_name} (${awsPerson.kerberos_id})`,
        kerberosId: awsPerson.kerberos_id,
        mitId: awsPerson.mitid,
        firstName: awsPerson.first_name,
        lastName: awsPerson.last_name,
        displayName: awsPerson.display_name,
    }));
};
exports.peopleResponseConverterAws = peopleResponseConverterAws;
class PeopleController extends BaseController_1.default {
    constructor() {
        super();
        this.fetchPeopleAws = (query) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_people + query, yield this.requestHeaderGet());
            if (response.status == 200) {
                let people = yield response.json();
                if (people) {
                    let peopleResults = (0, exports.peopleResponseConverterAws)(people);
                    return {
                        people: peopleResults
                    };
                }
                else {
                    return {
                        error: true
                    };
                }
            }
            else {
                return {
                    error: true
                };
            }
        });
        this.fetchPersonAws = (kerbId) => __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_people_detail + kerbId, yield this.requestHeaderGet());
            if (response.status === 200) {
                let detail = yield response.json();
                if (detail) {
                    return { detail: detail };
                }
                else {
                    return { error: true };
                }
            }
            else {
                return { error: true };
            }
        });
        this.url_people = `${this.apiHost}/${this.apiPathDigitalId}/search?q=`;
        this.url_people_detail = `${this.apiHost}/${this.apiPathCovid}/person/`;
    }
    putResident(id, food_delivery) {
        return __awaiter(this, void 0, void 0, function* () {
            let body = {
                food_delivery: food_delivery
            };
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(body)
            };
            let response = yield fetch(this.url_people_detail + `${id}/resident`, putOptions);
            if (response.status === 200) {
                let data = yield response.json();
                return { items: data };
            }
            else {
                return { error: true };
            }
        });
    }
}
const peopleController = new PeopleController();
exports.default = peopleController;
